/*
  AULBERY — Stock urgency panel V2 (snippets/as-stock-urgency-v2.liquid)
  Moved 1:1 from the snippet's inline <script>. Values that used to be
  Liquid-interpolated or literal are read from data-* attributes on the
  [data-as-stock-v2] root. The simulation engine (seed, PRNG, drops, viewer
  heartbeat) is unchanged. Additions: the picker lookup now also accepts
  ASBundleV4 / ASBundleV3 / ASBundle roots (only one picker renders at a
  time), and shopify:section:unload releases the interval, timeout, observer
  and document/window listeners.
*/
(function () {
  if (window.ASStockV2Booted) return;
  window.ASStockV2Booted = true;

  function initStock(root) {
    if (!root || root.dataset.asuInit === '1') return;

    var variantsJson = root.querySelector('[data-asu-variants]');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);
    if (!variants.length) return;
    root.dataset.asuInit = '1';
    var sectionId = root.dataset.section || '';
    var orderVolume = parseInt(root.dataset.orderVolume, 10) || 17000;
    var pollMs = parseInt(root.dataset.pollMs, 10) || 500;
    var heartbeatMs = parseInt(root.dataset.heartbeatMs, 10) || 250;
    var clickDelayMs = parseInt(root.dataset.clickDelayMs, 10);
    if (isNaN(clickDelayMs)) clickDelayMs = 30;
    var delays = {
      fastMin: parseInt(root.dataset.delayFastMin, 10) || 2000,
      fastMax: parseInt(root.dataset.delayFastMax, 10) || 3000,
      midMin: parseInt(root.dataset.delayMidMin, 10) || 4000,
      midMax: parseInt(root.dataset.delayMidMax, 10) || 6000,
      slowMin: parseInt(root.dataset.delaySlowMin, 10) || 8000,
      slowMax: parseInt(root.dataset.delaySlowMax, 10) || 11000
    };
    var lowStockText = root.dataset.lowStockText || 'Low stock';
    var labelSep = root.dataset.labelSep || '—';
    var optionSep = root.dataset.optionSep || '·';
    var stockStates = {};
    var activeVariantId = null;
    var viewerTimer = null;
    var viewerCount = null;
    var fitFloor = parseInt(root.dataset.fitFloor, 10) || 9;
    var fitShrink = parseInt(root.dataset.fitShrink, 10);
    if (isNaN(fitShrink)) fitShrink = 4;

    var titleEl = root.querySelector('[data-asu-title]');
    var badgeEls = root.querySelectorAll('[data-asu-badge]');
    var badgeEl = badgeEls.length ? badgeEls[badgeEls.length - 1] : null;
    var fillEl = root.querySelector('[data-asu-fill]');
    var dotEl = root.querySelector('.asu-dot');
    var soldEl = root.querySelector('[data-asu-sold]');
    var viewersEl = root.querySelector('[data-asu-viewers]');

    // Re-arm both pulses from the same instant. Called once after init so a
    // late-inserted element can't start its cycle offset from the other.
    function syncPulse() {
      var els = [];
      if (fillEl) els.push(fillEl);
      if (dotEl) els.push(dotEl);
      if (!els.length) return;
      els.forEach(function (el) { el.style.animationName = 'none'; });
      // force one reflow so the restart applies to both in the same frame
      void root.offsetWidth;
      els.forEach(function (el) { el.style.animationName = ''; });
    }

    function currentVariant() {
      // whichever AS bundle picker is on the page (only one renders at a time)
      var pickerIds = ['ASBundleV4-', 'ASBundleV3-', 'ASBundleV2-', 'ASBundle-'];
      var bundle = null;
      for (var p = 0; p < pickerIds.length && !bundle; p++) {
        bundle = document.getElementById(pickerIds[p] + sectionId);
      }
      if (bundle) {
        var colorEl = bundle.querySelector('.asb-swatch.is-selected');
        var sizeEl = bundle.querySelector('.asb-size.is-selected');
        if (colorEl && sizeEl) {
          var color = colorEl.dataset.color;
          var size = sizeEl.dataset.size;
          for (var i = 0; i < variants.length; i++) {
            var opts = variants[i].options || [];
            if (opts.indexOf(color) !== -1 && opts.indexOf(size) !== -1) return variants[i];
          }
        }
      }

      var input = document.querySelector('#MainProduct-' + sectionId + ' .product-variant-id')
        || document.querySelector('.product-variant-id');
      var id = input ? String(input.value) : null;
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === id) return variants[j];
      }
      return variants[0];
    }
    function selectionLabel(v) {
      return v && v.title ? v.title.replace(/ \/ /g, ' ' + optionSep + ' ') : '';
    }

    function fitTitleOnMobile() {
      if (!titleEl) return;

      titleEl.style.fontSize = '';
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      var baseSize = parseFloat(window.getComputedStyle(titleEl).fontSize) || 12;
      var fittedSize = baseSize;
      var minimumSize = Math.max(fitFloor, baseSize - fitShrink);

      while (titleEl.scrollWidth > titleEl.clientWidth && fittedSize > minimumSize) {
        fittedSize -= 1;
        titleEl.style.fontSize = fittedSize + 'px';
      }
    }

    function variantSeed(v) {
      var text = String(v.id || '') + '|' + String(v.title || 'variant');
      var hash = 2166136261;
      for (var i = 0; i < text.length; i++) {
        hash ^= text.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
      }
      return hash >>> 0;
    }

    function seededNumber(seed) {
      seed += 0x6D2B79F5;
      var n = seed;
      n = Math.imul(n ^ (n >>> 15), n | 1);
      n ^= n + Math.imul(n ^ (n >>> 7), n | 61);
      return ((n ^ (n >>> 14)) >>> 0) / 4294967296;
    }

    function simulationFor(v) {
      var seed = variantSeed(v);
      var startRoll = seededNumber(seed);
      var firstTimeRoll = seededNumber(seed + 1);
      var firstDropRoll = seededNumber(seed + 2);
      var secondTimeRoll = seededNumber(seed + 3);
      var secondDropRoll = seededNumber(seed + 4);
      var thirdChanceRoll = seededNumber(seed + 5);
      var thirdTimeRoll = seededNumber(seed + 6);
      var thirdDropRoll = seededNumber(seed + 7);
      var soldRoll = seededNumber(seed + 8);
      var startingQty = 9 + Math.floor(startRoll * 19);
      var alignedSold = 97 - Math.round(((startingQty - 9) / 18) * 7);
      var soldJitter = soldRoll < 0.33 ? -1 : (soldRoll > 0.66 ? 1 : 0);
      var startingSold = Math.max(90, Math.min(97, alignedSold + soldJitter));
      return {
        qty: startingQty,
        startingQty: startingQty,
        soldPct: startingSold,
        firstDelay: (1 + Math.floor(firstTimeRoll * 18)) * 1000,
        firstDrop: 1 + Math.floor(firstDropRoll * 3),
        secondDelay: (9 + Math.floor(secondTimeRoll * 27)) * 1000,
        secondDrop: 1 + Math.floor(secondDropRoll * 4),
        hasThird: thirdChanceRoll < 0.4,
        thirdDelay: (20 + Math.floor(thirdTimeRoll * 36)) * 1000,
        thirdDrop: 1 + Math.floor(thirdDropRoll * 3),
        step: 0,
        nextAt: null
      };
    }

    function stateFor(v) {
      if (!stockStates[v.id]) stockStates[v.id] = simulationFor(v);
      return stockStates[v.id];
    }

    function render(v) {
      var state = stateFor(v);
      var qty = state.qty;
      var pct = state.soldPct;
      if (pct < 1) pct = 1;
      if (pct > 99) pct = 99;

      root.hidden = false;

      var label = selectionLabel(v);
      var prefix = root.dataset.prefix ? root.dataset.prefix + ' ' : '';
      titleEl.textContent = prefix + qty + ' ' + root.dataset.title + (label ? ' ' + labelSep + ' ' + label : '');
      fitTitleOnMobile();

      if (badgeEl) {
        var badgeMode = root.dataset.badgeMode || 'quantity';
        if (badgeMode === 'hidden') {
          badgeEl.style.display = 'none';
        } else {
          badgeEl.style.display = '';
          badgeEl.textContent = badgeMode === 'low_stock'
            ? lowStockText
            : root.dataset.badge.replace('{qty}', qty);
        }
      }

      fillEl.style.width = pct + '%';
      if (soldEl) soldEl.textContent = root.dataset.sold.replace('{pct}', Math.round(pct));

      if (viewersEl && !root.dataset.viewersOff) {
        var lo = parseInt(root.dataset.viewersMin, 10) || 84;
        var hi = parseInt(root.dataset.viewersMax, 10) || 96;
        if (viewerCount === null) {
          var displayedCount = parseInt(viewersEl.textContent, 10);
          var startingRange = Math.max(1, Math.floor((hi - lo) * 0.7));
          viewerCount = isNaN(displayedCount)
            ? lo + Math.floor(Math.random() * (startingRange + 1))
            : displayedCount;
        }
        viewersEl.textContent = root.dataset.viewersLabel.replace('{n}', viewerCount);
      }
    }

    function scheduleViewerChange() {
      if (!viewersEl || root.dataset.viewersOff) return;
      if (viewerTimer !== null) window.clearTimeout(viewerTimer);
      var lo = parseInt(root.dataset.viewersMin, 10) || 84;
      var hi = parseInt(root.dataset.viewersMax, 10) || 96;
      var ceiling = hi + 30;
      var now = Date.now();

      function nextViewerDelay() {
        var roll = Math.random();
        if (roll < 0.30) return delays.fastMin + Math.floor(Math.random() * (delays.fastMax - delays.fastMin + 1));
        if (roll < 0.85) return delays.midMin + Math.floor(Math.random() * (delays.midMax - delays.midMin + 1));
        return delays.slowMin + Math.floor(Math.random() * (delays.slowMax - delays.slowMin + 1));
      }

      if (!root.dataset.asuViewerNextAt) {
        root.dataset.asuViewerNextAt = String(now + nextViewerDelay());
      }

      viewerTimer = window.setTimeout(function viewerHeartbeat() {
        viewerTimer = null;
        var tickNow = Date.now();
        var nextAt = parseInt(root.dataset.asuViewerNextAt, 10) || tickNow;

        if (tickNow >= nextAt) {
          var sharedChanges;
          try { sharedChanges = JSON.parse(root.dataset.asuViewerChanges || '[]'); }
          catch (err) { sharedChanges = []; }

          if (!sharedChanges.length) {
            sharedChanges = [1, 1, 1, 1, 1, -1];
            for (var i = sharedChanges.length - 1; i > 0; i--) {
              var swapWith = Math.floor(Math.random() * (i + 1));
              var held = sharedChanges[i];
              sharedChanges[i] = sharedChanges[swapWith];
              sharedChanges[swapWith] = held;
            }
          }

          var change = sharedChanges.shift();
          var displayed = parseInt(viewersEl.textContent, 10);
          if (isNaN(displayed)) displayed = lo;
          if (displayed >= ceiling && change > 0) change = -1;
          if (displayed <= lo && change < 0) change = 1;

          viewerCount = Math.max(lo, Math.min(ceiling, displayed + change));
          viewersEl.textContent = root.dataset.viewersLabel.replace('{n}', viewerCount);
          root.dataset.asuViewerChanges = JSON.stringify(sharedChanges);

          root.dataset.asuViewerNextAt = String(tickNow + nextViewerDelay());
        }

        scheduleViewerChange();
      }, heartbeatMs);
    }

    function activateSequence(v) {
      var state = stateFor(v);
      if (state.step === 0) state.nextAt = Date.now() + state.firstDelay;
      else if (state.step === 1) state.nextAt = Date.now() + state.secondDelay;
      else if (state.step === 2 && state.hasThird) state.nextAt = Date.now() + state.thirdDelay;
      else state.nextAt = null;
    }

    function processSequence(v) {
      var state = stateFor(v);
      if (!state.nextAt || Date.now() < state.nextAt) return;

      if (state.step === 0) {
        state.qty = Math.max(1, state.qty - state.firstDrop);
        state.soldPct = Math.min(99, state.soldPct + 1);
        state.step = 1;
      } else if (state.step === 1) {
        state.qty = Math.max(1, state.qty - state.secondDrop);
        state.soldPct = Math.min(99, state.soldPct + 1);
        state.step = 2;
      } else if (state.step === 2 && state.hasThird) {
        state.qty = Math.max(1, state.qty - state.thirdDrop);
        state.soldPct = Math.min(99, state.soldPct + 1);
        state.step = 3;
      }
      activateSequence(v);
    }

    function update() {
      var v = currentVariant();
      if (!v) return;

      if (String(v.id) !== String(activeVariantId)) {
        activeVariantId = String(v.id);
        activateSequence(v);
      }
      processSequence(v);
      render(v);
    }

    update();
    syncPulse();
    scheduleViewerChange();

    // follow the bundle picker / variant changes
    var formInput = document.querySelector('#MainProduct-' + sectionId + ' .product-variant-id');
    var inputObserver = null;
    if (formInput && window.MutationObserver) {
      inputObserver = new MutationObserver(update);
      inputObserver.observe(formInput, { attributes: true, attributeFilter: ['value'] });
    }
    function onDocumentClick(e) {
      if (e.target.closest && e.target.closest('.asb-swatch, .asb-size, .asb-pack')) {
        setTimeout(update, clickDelayMs);
      }
    }
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('variant:change', update);
    window.addEventListener('resize', fitTitleOnMobile);
    var pollTimer = window.setInterval(update, pollMs);

    root.asuCleanup = function () {
      window.clearInterval(pollTimer);
      if (viewerTimer !== null) window.clearTimeout(viewerTimer);
      viewerTimer = null;
      if (inputObserver) inputObserver.disconnect();
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('variant:change', update);
      window.removeEventListener('resize', fitTitleOnMobile);
    };
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-as-stock-v2]');
    for (var i = 0; i < roots.length; i++) initStock(roots[i]);
  }
  function unloadAll(e) {
    var roots = document.querySelectorAll('[data-as-stock-v2]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (e && e.target && e.target.contains && !e.target.contains(root)) continue;
      if (typeof root.asuCleanup === 'function') { root.asuCleanup(); root.asuCleanup = null; }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', unloadAll);
})();

